import http from "./axios-config";

const API_URL = "/auth"; // 基础路径已在axios配置中设置

export async function login(email, password) {
  try {
    const response = await http.post(`${API_URL}/login`, { email, password });

    // 如果登录成功，设置认证令牌用于后续请求
    if (response.data && response.data.token) {
      setAuthToken(response.data.token);
      localStorage.setItem("refreshToken", response.data.refreshToken || "");
      localStorage.setItem("tokenExpiration", response.data.expiration || "");
    }

    return response.data;
  } catch (error) {
    console.error("Login error:", error);
    if (error.response && error.response.data) {
      throw new Error(error.response.data.message || "登录失败");
    }
    throw new Error("登录过程中发生错误，请稍后再试");
  }
}

/**
 * 获取图形验证码
 * @returns {Promise<{captchaId: string, captchaImage: string}>}
 */
export async function getCaptcha() {
  try {
    console.log('正在请求验证码...');
    const response = await http.get(`${API_URL}/captcha`, {
      params: { t: Date.now() }, // 防止缓存
      validateStatus: function (status) {
        // 确保即使返回 500 也不会抛出异常，而是进入 catch 块
        return status >= 200 && status < 500;
      }
    });
    
    console.log('验证码响应状态:', response.status);
    console.log('验证码响应数据:', response.data);
    
    if (response.status !== 200 || !response.data) {
      throw new Error(response.data?.message || '获取验证码失败');
    }
    
    return response.data;
  } catch (error) {
    console.error("获取验证码失败:", error);
    if (error.response && error.response.data) {
      throw new Error(error.response.data.message || "获取验证码失败");
    }
    throw error instanceof Error ? error : new Error("获取验证码时发生错误，请稍后再试");
  }
}

/**
 * 发送邮箱验证码
 * @param {string} email 邮箱地址
 * @param {string} captcha 图形验证码
 * @param {string} captchaId 图形验证码ID
 * @returns {Promise<{success: boolean, message: string}>}
 */
export async function sendEmailVerificationCode(email, captcha, captchaId) {
  try {
    const response = await http.post(`${API_URL}/send-email-code`, {
      email,
      captcha,
      captchaId
    });
    return response.data;
  } catch (error) {
    console.error("发送邮箱验证码失败:", error);
    if (error.response && error.response.data) {
      throw new Error(error.response.data.message || "发送验证码失败");
    }
    throw new Error("发送验证码时发生错误，请稍后再试");
  }
}

export async function register(userData) {
  try {
    console.log("Sending registration request with data:", userData);

    const response = await http.post(`${API_URL}/register`, userData, {
      withCredentials: true,
    });

    return response.data;
  } catch (error) {
    console.error("Registration error:", error);
    if (error.response && error.response.data) {
      throw new Error(error.response.data.message || "注册失败");
    }
    throw new Error("注册过程中发生错误，请稍后再试");
  }
}

export async function refreshToken(token, refreshToken) {
  try {
    const response = await http.post(`${API_URL}/refresh-token`, {
      token,
      refreshToken,
    });

    if (response.data && response.data.token) {
      localStorage.setItem("token", response.data.token);
      localStorage.setItem("refreshToken", response.data.refreshToken || "");
      localStorage.setItem("tokenExpiration", response.data.expiration || "");
    }

    return response.data;
  } catch (error) {
    console.error("Token refresh error:", error);
    if (error.response && error.response.data) {
      throw new Error(error.response.data.message || "刷新令牌失败");
    }
    throw new Error("刷新令牌过程中发生错误，请稍后再试");
  }
}

export async function logout() {
  // Just clear the token on the client side
  localStorage.removeItem("token");
  localStorage.removeItem("refreshToken");
  localStorage.removeItem("tokenExpiration");
  return Promise.resolve();
}

// Helper function to store the auth token
export function setAuthToken(token) {
  // Store token in localStorage, headers are set by axios interceptors
  localStorage.setItem("token", token);
}
